import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M10.333 2.583A1.916 1.916 0 0 1 12.249 4.5v7.416h1.584a.75.75 0 0 1 0 1.5H2.166a.75.75 0 0 1 0-1.5h1.583V4.5a1.92 1.92 0 0 1 1.917-1.917zM9.166 7.25a.75.75 0 0 0-.75.75v.006l.004.076a.75.75 0 0 0 1.492 0l.004-.076V8a.75.75 0 0 0-.75-.75"
    }, null, -1)
  ]))]))
}
export default { render: render }